import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { RentalApplicationRepository } from '~/repositories/rentalApplicationRepository';
import { rentalApplicationPaymentSettingRepository } from '~/repositories/settings/rentalApplicationPaymentSettingsRepository';
import type { RentalApplicationBillingSettings, RentalApplicationGeneralSettings } from '~/swagger/settings/Api';

export const createRentalApplicationSettingsController = () => {
  const rentalApplicationRepository = new RentalApplicationRepository();
  const [settings, setSettings] = createSignal<RentalApplicationGeneralSettings>();
  const [applicationPaymentSettings, setApplicationPaymentSettings] = createSignal<RentalApplicationBillingSettings>();

  const getSettings = async () => {
    const nextSettings = await rentalApplicationRepository.getApplicationSettings();
    setSettings(nextSettings);
    return nextSettings;
  };

  const getApplicationPaymentSettings = async () => {
    const nextPaymentSettings = await rentalApplicationPaymentSettingRepository.getRentalApplicationPaymentSettings();
    setApplicationPaymentSettings(nextPaymentSettings);
    return nextPaymentSettings;
  };

  const initState = async () => {
    await Promise.all([getSettings(), getApplicationPaymentSettings()]);
  };

  return {
    settings,
    applicationPaymentSettings,
    initState,
  };
};

export const [RentalApplicationSettingsProvider, useRentalApplicationSettings] = createMagicDoorContext(
  'RentalApplicationSettings',
  createRentalApplicationSettingsController
);
